import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SearchBars, Tabbles } from "../../../components";
import { PiBinoculars, PiDotsThreeOutlineVertical } from "react-icons/pi";
import { LuEuro } from "react-icons/lu";
import { Commons } from "../../../utilities";
import { useDispatch } from "react-redux";
import { actionPatient } from "../../../redux/actions";
import { useTranslation } from "react-i18next";

const MyFinances = ({
  getClinicDoctorData,
  getAppointmentsData,
  options1,
  loginData,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);


  useEffect(() => {
    if (getClinicDoctorData) {
      const newOption = getClinicDoctorData?.result?.map((item) => ({
        value: item.clinicGuid,
        label: item.clinicName,
      }));
      setOptions(newOption);
    }
  }, [getClinicDoctorData]);
  const patientAppointments =
    getAppointmentsData?.result?.patientAppointments || [];
  const startDate =
    patientAppointments.length > 0
      ? Commons.formatDateWithOrdinal(
        new Date(patientAppointments[0].appointmentDateTime)
      )
      : "";
  const endDate =
    patientAppointments.length > 0
      ? Commons.formatDateWithOrdinal(
        new Date(
          patientAppointments[
            patientAppointments.length - 1
          ].appointmentDateTime
        )
      )
      : "";

  const handleChange = (type, value) => {
    switch (type) {
      case "search":
        setSearch(value);
        break;
      case "location":
        setSelectedLocation(value);
        break;
      case "clinic":
        setSelectedClinic(value);
        break;
      default:
        break;
    }
  };

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  const onSearchClick = () => {
    let formattedFromDate = null;
    let formattedToDate = null;

    if (dateRange?.[0] && dateRange?.[1]) {
      const fromDate = new Date(dateRange[0].getTime() - dateRange[0].getTimezoneOffset() * 60000);
      const toDate = new Date(dateRange[1].getTime() - dateRange[1].getTimezoneOffset() * 60000);

      formattedFromDate = fromDate.toISOString().split(".")[0] + ".000";
      formattedToDate = toDate.toISOString().split(".")[0] + ".000";
    }
    let clinicGuid = selectedClinic?.value || '';
    if (clinicGuid === loginData.clinicGuid) {
      clinicGuid = '';
    }
    const appointmentTypes = selectedLocation?.map(item => item.value) || [];

    // pageSize, currentPage, search, sortExp, sortDir, patientGuid, doctorGuid, appointmentStatuses, fromDate, toDate, isRequiredRefundData, IsRequiredCommissionData, UserCurrency, UserTimeZone, clinicGuid, isOwn, isAnother, LanguageId, appointmentTypes,

    dispatch(actionPatient.getAppointments(10, 1, search, "", "", "", loginData.userGuid, null, formattedFromDate, formattedToDate, true, true, loginData?.currencyCode, loginData.timeZoneId, clinicGuid, true, false, loginData?.languageId, appointmentTypes, null))

  };

  return (
    <Row>
      <Col md={12}>
        <SearchBars.SearchBar
          className="search-bar"
          showDate={true}
          showSelect1={true}
          showSelect2={true}

          datepickermd={3}
          selectColmd1={3}
          selectColmd2={2}
          searchColmd={2}
          buttonColmd={2}

          datepickerlg={3}
          selectCollg1={3}
          selectCollg2={3}
          searchCollg={2}
          buttonCollg={1}

          searchGrpClassName="form-group1"
          select1Classname="select3"
          select2Classname="select3"
          select1Options={options1}
          select2Options={options}
          searchPlaceholder={t("Search")}
          select1Placeholder={t("location")}
          select2Placeholder={t("Clinic")}
          cDateRangePlaceholder={t("enter") + " " + t("date")}
          cDateRangeClassname="custom-date-range-picker"
          buttonClassname="btn-solid-Aqua_Teal"
          buttonChildren={<PiBinoculars className="bionCularIcon" />}
          onSearchClick={onSearchClick}

          dateRange={dateRange}
          select1Value={selectedLocation}
          select2Value={selectedClinic}
          searchValue={search}

          onDateRangeChange={handleDateRangeChange}
          onLocationChange={(selected) => handleChange("location", selected)}
          onClinicChange={(selected) => handleChange("clinic", selected)}
          onSearchChange={(e) => setSearch(e.target.value)}
        />
      </Col>
      <Col md={12} className="table-col">
        <Tabbles.TableBlk
          headerIcon={<LuEuro className="header-Icn" />}
          heading={`${t("My")} ${t("Finances")}`}
          subHeading={
            <span>
              {t("From")}, {startDate} - {endDate}
            </span>
          }
          columns={[
            `${t("booking_id")}`,
            `${t("clinics_name")}`,
            `${t("patient_name")}`,
            `${t("time_&_date")}`,
            loginData?.currencyCode,
            `${t("consultation_type")}`,
            "",
          ]}
          data={getAppointmentsData?.result?.patientAppointments?.map(
            (Appointment) => ({
              [t("booking_id")]: Appointment.bookingId,
              [t("clinics_name")]: Appointment.clinicName,
              [t("patient_name")]:
                Appointment.patientFirstName +
                " " +
                Appointment.patientLastName,
              [t("time_&_date")]: (
                <>
                  <div>
                    {new Date(
                      Appointment.appointmentDateTime
                    ).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>
                  <div>
                    {new Date(Appointment.appointmentDateTime)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, " - ")}
                  </div>
                </>
              ),
              [loginData?.currencyCode]: Appointment.totalAmount,
              [t("consultation_type")]: Appointment.appointmentType,
              "": <PiDotsThreeOutlineVertical className="moreAction" />,
            })
          )}
          tabbleClassname="tabble"
        />
      </Col>
    </Row>
  );
};

export default MyFinances;
